// src/components/settings/Localization.jsx
import React, { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

export default function Localization() {
  const [languageSwitcher, setLanguageSwitcher] = useState(false);

  return (
    <div className="localization-settings">
      <h5 className="mb-3">Localization</h5>

      <div className="section-border">
        {/* TOP SECTION */}
        <Row>
          {/* Language */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Language</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>English</option>
                <option>Telugu</option>
                <option>Hindi</option>
              </Form.Select>

              <div className="d-flex align-items-center mt-2">
                <Form.Check
                  type="switch"
                  checked={languageSwitcher}
                  onChange={() => setLanguageSwitcher(!languageSwitcher)}
                />
                <span className="ms-2 small text-muted">
                  Language Switcher
                </span>
              </div>
            </Form.Group>
          </Col>

          {/* Timezone */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Timezone</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>Asia/Kolkata</option>
                <option>UTC</option>
                <option>America/New_York</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Date Format */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Date Format</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>YYYY-MM-DD</option>
                <option>MM/DD/YYYY</option>
                <option>DD/MM/YYYY</option>
                <option>YYYY/MM/DD</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Time Format */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Time Format</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>12 Hours</option>
                <option>24 Hours</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Financial Year */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Financial Year</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>2024-2025</option>
                <option>2025-2026</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Starting Month */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Starting Month</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>January</option>
                <option>April</option>
                <option>July</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <hr />

        {/* CURRENCY */}
        <h6>Currency Information</h6>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Currency</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>INR</option>
                <option>USD</option>
                <option>EUR</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Currency Symbol</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>₹</option>
                <option>$</option>
                <option>€</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Currency Position</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>Before Amount</option>
                <option>After Amount</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Decimal Separator</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>.</option>
                <option>,</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Thousand Separator</Form.Label>
              <Form.Select>
                <option>.</option>
                <option>,</option>
                <option>Space</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <hr />

        {/* COUNTRY */}
        <h6>Country Settings</h6>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Countries Restriction</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>India</option>
                <option>USA</option>
                <option>UK</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <hr />

        {/* FILE SETTINGS */}
        <h6>File Settings</h6>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Allowed Files</Form.Label>
              <Form.Select>
                <option>jpg</option>
                <option>png</option>
                <option>gif</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Max File Size</Form.Label>
              <Form.Control defaultValue="5000 MB" />
            </Form.Group>
          </Col>
        </Row>

        {/* ACTION */}
        <div className="text-end mt-3">
          <Button variant="light">Cancel</Button>
          <Button className="btn-orange ms-2">Save</Button>
        </div>
      </div>
      <style>
          {
               `
               .localization-settings .section-border {
  border: 1px solid #e5e7eb;
  padding: 20px;
  border-radius: 6px;
  background: #fff;
}

.localization-settings h6 {
  font-weight: 600;
  margin-bottom: 15px;
}

.localization-settings select,
.localization-settings input {
  height: 40px;
  font-size: 14px;
}

/* Orange highlight feel */
.localization-settings select:focus {
  border-color: #ff6a00;
  box-shadow: 0 0 0 0.1rem rgba(255, 106, 0, 0.25);
}

.btn-orange {
  background: #ff6a00;
  border: none;
  color: #fff;
}

.btn-orange:hover {
  background: #e65c00;
}

/* MOBILE */
@media (max-width: 768px) {
  .localization-settings .row > div {
    width: 100%;
  }
}`
          }
      </style>
    </div>
  );
}